import {Box, Stack} from '@mui/material';
import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import {MainFooter, MainHeader, PageWrapperLayout, StyledGrid} from 'presentation/components';
import {FeaturesEnum, HomeEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {translations} from 'presentation/translations-new';
import {PerksTaggingEnum} from 'main/analytics/gaTagsEnum';
import {useAccountInformation, useMediaQueries} from '../hooks';
import {AdditionalCoverage, PerksClub, Recommendation} from './components';

import {useConciergeBenefits} from '../hooks/useConciergeBenefits';
import {Concierge} from './components/Concierge';
import {ContractNow} from './components/ContractNow';
import {Lifeplace} from './components/Lifeplace';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

const {perks} = translations['pt-br'].others.sidebar;

export function Perks() {
	const {isMobile} = useMediaQueries();
	const navigate = useNavigate();
	const {isGndiSaoPaulo, isNotredameSaude} = useHostName();
	const {accesses} = useAccountInformation();
	const {showConciergeButton} = useConciergeBenefits();

	const {isEnabled: isHideRecommendationEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_HIDE_RECOMMENDATION,
	);

	const handleBack = useCallback(() => {
		navigate(HomeEnum.HOME_PAGE);
	}, []);

	const shouldShowAdditionalCoverage =
		(isGndiSaoPaulo || isNotredameSaude) && accesses.hasBenefits;

	const shouldHideWhoIndicates = isNotredameSaude && isHideRecommendationEnabled;

	const renderSizeGrid = () => {
		if (shouldShowAdditionalCoverage && !showConciergeButton) {
			return {
				gridLgSize: 3,
				gridMdSize: 6,
			};
		}

		if (!shouldShowAdditionalCoverage && showConciergeButton) {
			return {
				gridLgSize: 3,
				gridMdSize: 6,
			};
		}

		if (shouldShowAdditionalCoverage && showConciergeButton) {
			return {
				gridLgSize: 4,
				gridMdSize: 6,
			};
		}

		return {
			gridLgSize: 4,
			gridMdSize: 4,
		};
	};

	const {gridLgSize, gridMdSize} = renderSizeGrid();

	return (
		<PageWrapperLayout title={perks}>
			<MainHeader
				title={perks}
				handleBack={handleBack}
				dataTagId={{
					backButtonRoute: PerksTaggingEnum.CLICK_VOLTAR_BENEFICIOS,
				}}
			/>
			<Stack p={isMobile ? 2 : 4} gap={3} maxWidth={1280}>
				<StyledGrid.Root flex={1}>
					{showConciergeButton ? (
						<StyledGrid.Item xs={12} sm={12} md={gridMdSize} lg={gridLgSize}>
							<Concierge />
						</StyledGrid.Item>
					) : null}
					{shouldShowAdditionalCoverage ? (
						<StyledGrid.Item xs={12} sm={12} md={gridMdSize} lg={gridLgSize}>
							<AdditionalCoverage />
						</StyledGrid.Item>
					) : null}
					<StyledGrid.Item xs={12} sm={12} md={gridMdSize} lg={gridLgSize}>
						<PerksClub />
					</StyledGrid.Item>
					{shouldHideWhoIndicates ? null : (
						<StyledGrid.Item xs={12} sm={12} md={gridMdSize} lg={gridLgSize}>
							<Recommendation />
						</StyledGrid.Item>
					)}
					<StyledGrid.Item xs={12} sm={12} md={gridMdSize} lg={gridLgSize}>
						<ContractNow />
					</StyledGrid.Item>
				</StyledGrid.Root>

				{isGndiSaoPaulo || isNotredameSaude ? <Lifeplace /> : null}
			</Stack>
			<Box mt="auto">
				<MainFooter />
			</Box>
		</PageWrapperLayout>
	);
}
